export default class GetDefaultWorkTypePricingByIdError extends Error {

}
